// extracted by mini-css-extract-plugin
export default {"pageContainer":"TicketSubmissionView_pageContainer__+Tk0L","ticketSubmissionConfirmationContainer":"TicketSubmissionView_ticketSubmissionConfirmationContainer__TtT9Q"};